module.exports = __webpack_public_path__ + "img/halloween-rock-2.ebbb5a5b.svg";